export default "__VITE_ASSET__CJCr3lI9__"